(() => {
  if (window.campaignVideoModal) {
    window.campaignVideoModal.init(document);
    return;
  }

  let activeModal = null;
  let activeTrigger = null;
  const closeTimers = new WeakMap();
  const animationDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;

  const closeModal = () => {
    if (!activeModal) return;

    const modal = activeModal;
    const frame = modal.querySelector('[data-campaign-video-frame]');
    const previousTimer = closeTimers.get(modal);

    if (previousTimer) window.clearTimeout(previousTimer);

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    frame.removeAttribute('src');
    document.body.classList.remove('campaign-video-modal-open');

    const closeTimer = window.setTimeout(() => {
      modal.hidden = true;
      closeTimers.delete(modal);
    }, animationDuration);
    closeTimers.set(modal, closeTimer);

    activeTrigger?.focus();
    activeModal = null;
    activeTrigger = null;
  };

  const setup = (trigger) => {
    if (trigger.dataset.campaignVideoInitialized === 'true') return;

    const modalId = trigger.getAttribute('aria-controls');
    const modal = document.getElementById(modalId);
    const frame = modal?.querySelector('[data-campaign-video-frame]');

    if (!modal || !frame) return;

    const openModal = () => {
      const youtubeId = trigger.dataset.youtubeId?.trim();
      if (!/^[A-Za-z0-9_-]{11}$/.test(youtubeId)) return;

      if (activeModal && activeModal !== modal) closeModal();

      const previousTimer = closeTimers.get(modal);
      if (previousTimer) {
        window.clearTimeout(previousTimer);
        closeTimers.delete(modal);
      }

      frame.src = `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('campaign-video-modal-open');

      activeModal = modal;
      activeTrigger = trigger;

      window.requestAnimationFrame(() => {
        modal.classList.add('is-open');
        modal.querySelector('[data-campaign-video-close]')?.focus();
      });
    };

    trigger.addEventListener('click', openModal);
    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      openModal();
    });

    modal.querySelectorAll('[data-campaign-video-close]').forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    trigger.dataset.campaignVideoInitialized = 'true';
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-campaign-video-trigger]').forEach(setup);
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  window.campaignVideoModal = { init, close: closeModal };
  init();
})();
